"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgLanesChange(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 0 16 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M16.45 13.966L18 15v5h-3v-3l-1.651-1.102 3.101-1.932zM15 9h-.001H15V7.989l-2 .001L16.5 4 20 7.99l-2-.001V11l-3 2h.001l-3 2H12l-3 2v3H6v-5l9-6zM7.5 4L11 7.99l-2-.001V9l1.652 1.1-3.101 1.933L6 11V7.989L4 7.99 7.5 4z" })));
}
exports.default = tombacIcon_1.default('LanesChange')(SvgLanesChange);
//# sourceMappingURL=LanesChange.js.map